<template>
  <WizardContainer
    width="792px"
    height="624px"
  >
    <WizardContent>
      <template #flashMessage>
        <EduWarningFlashMessage :email="email" />
      </template>
      <h4 class="mt-6 mb-8">
        Password Reset
      </h4>
      <p class="p3 mb-9">
        To reset your account password please enter your email address below.
      </p>
      <v-form
        ref="form"
        v-model="valid"
        class="form"
        action="/not-found"
        @submit.prevent="submitForm"
      >
        <DpplTextField
          v-model="email"
          class="mb-3"
          label="Email"
          :rules="emailRules"
          validate-on="blur"
        />
        <DpplSignupFormButton
          type="submit"
          block
          :loading="loading"
        >
          RESET PASSWORD
        </DpplSignupFormButton>
      </v-form>
    </WizardContent>
  </WizardContainer>
</template>

<script>
import WizardContainer from '@/components/shared/WizardContainer.vue';
import WizardContent from '@/components/shared/WizardContent.vue';
import { signupSendPasswordResetEmail } from '@/api/signup';
import validation from '@/helpers/validation';
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import DpplSignupFormButton from '@/components/datapeople/DpplSignupFormButton.vue';
import EduWarningFlashMessage from '@/components/shared/EduWarningFlashMessage.vue';
import { mapActions } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'PasswordReset',
  components: {
    WizardContainer,
    WizardContent,
    DpplTextField,
    DpplSignupFormButton,
    EduWarningFlashMessage,
  },
  emits: ['track-page-load'],
  data() {
    return {
      email: '',
      emailRules: [
        (v) => !validation.isEmpty(v) || 'Email is required',
        (v) => validation.emailFormat(v) || 'Email format is invalid',
        (v) => validation.emailBlacklist(v) || 'Please provide your work email address.',
        (v) => validation.roleEmailBlacklist(v) || 'Role-based email addresses are not valid. Please use your individual company email address.',
        (v) => (v && v.length <= 250) || 'Email is too long',
      ],
      valid: false,
      loading: false,
    };
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Password Reset' });
  },
  methods: {
    ...mapActions(useWizard, ['updateFlash']),
    async submitForm() {
      try {
        const formValidateResult = await this.$refs.form.validate();
        if (formValidateResult.valid) {
          this.loading = true;
          const responseJSON = await signupSendPasswordResetEmail({
            email: this.email,
          });
          if (responseJSON.success === true) {
            this.$router.push({
              name: 'password-reset-success',
              query: {
                email: this.email,
              },
            });
          }
        }
      } catch (e) {
        if (!e.message || e.message.charAt(0) !== '{') {
          this.updateFlash({ message: `Password reset error: ${e.message}` });
          throw e;
        }
        const responseJSON = JSON.parse(e.message);
        if (responseJSON.errors && responseJSON.errors.sso_mandatory) {
          if (responseJSON.errors.is_google) {
            window.location.href = '/signup/google';
          } else if (responseJSON.errors.is_microsoft) {
            window.location.href = '/signup/microsoft';
          } else {
            window.location.href = `/login/${responseJSON.errors.provider}`;
          }
          return;
        }
        this.updateFlash({ message: 'Something went wrong' });
        throw e;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.form {
  width: 100%;
}
</style>
